import React, { useState, useEffect } from 'react';
import { useCampaign } from '../../../context/CampaignContext';
import CampaignBannerCarousel from '../../Campaign/CampaignBannerCarousel';
import { CAMPAIGN_POSITIONS } from '../../../data/campaignModels';

/**
 * Banner Wrapper for Nurse App
 * Shows CampaignBannerCarousel if campaigns exist, otherwise shows fallback
 */
const NurseBannerWrapper = ({ fallback, positionId = CAMPAIGN_POSITIONS.NURSE_HOMEPAGE_TOP }) => {
  const { campaigns, loadCampaignsForPosition } = useCampaign();
  const [hasCampaigns, setHasCampaigns] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCampaigns = async () => {
      try {
        setLoading(true);
        console.log('[NurseBannerWrapper] Loading campaigns for position:', positionId);
        const loadedCampaigns = await loadCampaignsForPosition(positionId, 'th');
        const hasCampaigns = loadedCampaigns && loadedCampaigns.length > 0;
        console.log('[NurseBannerWrapper] Loaded campaigns:', loadedCampaigns?.length || 0, 'hasCampaigns:', hasCampaigns);
        setHasCampaigns(hasCampaigns);
      } catch (error) {
        console.error('[NurseBannerWrapper] Error loading banner campaigns:', error);
        setHasCampaigns(false);
      } finally {
        setLoading(false);
      }
    };

    loadCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positionId]);

  // Also check campaigns state from context (but only if they match our positionId)
  useEffect(() => {
    // Check if campaigns in context match our positionId
    // Note: This is a fallback check, the main check is from loadCampaignsForPosition
    if (campaigns && campaigns.length > 0) {
      // Verify that campaigns are for our position
      const matchingCampaigns = campaigns.filter(c => {
        const positionConfig = c.positions?.find(p => p.positionId === positionId);
        return positionConfig && positionConfig.enabled;
      });
      if (matchingCampaigns.length > 0) {
        setHasCampaigns(true);
      } else if (campaigns.length === 0 && !loading) {
        setHasCampaigns(false);
      }
    } else if (campaigns && campaigns.length === 0 && !loading) {
      setHasCampaigns(false);
    }
  }, [campaigns, loading, positionId]);

  if (loading) {
    // Show fallback while loading
    console.log('[NurseBannerWrapper] Loading, showing fallback');
    return fallback || null;
  }

  if (hasCampaigns) {
    console.log('[NurseBannerWrapper] Has campaigns, rendering CampaignBannerCarousel');
    return <CampaignBannerCarousel positionId={positionId} fallback={fallback} />;
  }

  console.log('[NurseBannerWrapper] No campaigns, showing fallback');
  return fallback || null;
};

export default NurseBannerWrapper;

